import { Component, Output, ViewChild, EventEmitter, AfterViewChecked, Input, OnChanges } from '@angular/core';
import { WebMemberProfile } from '../members.interfaces';
import { MemberService } from '../services/member.service';
import * as moment from 'moment'
const alertify = require("alertify.js");

declare var jQuery: any;

@Component({
  selector: 'ch-web-profile-modal-dialog',
  templateUrl: './web-profile-modal-dialog.component.html',
  styleUrls: ['./web-profile-modal-dialog.component.css'],
})
export class WebProfileModalDialogComponent implements OnChanges, AfterViewChecked {
  @Input() public show: boolean;
  @Input() public memberId: string;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  private change: boolean;

  public loading = false;
  public webProfile: WebMemberProfile;

  constructor(private memberService: MemberService) { }

  ngOnInit() {
    alertify.logPosition("bottom right");
    this.getWebProfile();
  }

  ngOnChanges() {
    if (this.show) {
      this.change = true;
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false,
        })
        .on('hidden.bs.modal', e => {
          this.onClose.emit(e);
        });

      this.change = false;
    }
  }

  private getWebProfile() {
    this.loading = true;
    this.memberService.getMemberWebProfile(this.memberId).subscribe(
      resp => {
        this.webProfile = resp.json();

        // Change the dates to Moment objects
        this.webProfile.subscriptionEndDate = this.webProfile.subscriptionEndDate ? moment(this.webProfile.subscriptionEndDate) : null;
        this.webProfile.freeTrialEndDate = this.webProfile.freeTrialEndDate ? moment(this.webProfile.freeTrialEndDate) : null;
        this.webProfile.subscriptionCancelledDate = this.webProfile.subscriptionCancelledDate ? moment(this.webProfile.subscriptionCancelledDate) : null;

        this.loading = false;
      },
      error => {
        alertify.error(error);
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/web-profile-modal-dialog/web-profile-modal-dialog.component.ts